<div>
    <section class="customer-home__quick-quote" id="quick-quote">
        <div class="quick-quote" *ngIf="!appSubmitted">
            <quick-quote></quick-quote>
        </div>
    </section>
</div>